import { render } from "./PropertyMovementCard.vue?vue&type=template&id=97fbbb28&scoped=true"
import script from "./PropertyMovementCard.vue?vue&type=script&lang=js"
export * from "./PropertyMovementCard.vue?vue&type=script&lang=js"

import "./PropertyMovementCard.vue?vue&type=style&index=0&id=97fbbb28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fbbb28"]])

export default __exports__